import { render, staticRenderFns } from "./ClientInfoCard.vue?vue&type=template&id=4f3046d8&scoped=true&"
import script from "./ClientInfoCard.vue?vue&type=script&lang=js&"
export * from "./ClientInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientInfoCard.vue?vue&type=style&index=0&id=4f3046d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3046d8",
  null
  
)

export default component.exports